import React, { useMemo } from "react";
import Select from "react-select";

export default function CustomSelect({
  name,
  isDisabled,
  isMulti,
  closeMenuOnSelect,
  placeholder,
  options = [],
  value,
  onSelect,
}) {
  const handleSelect = (option) => {
    onSelect &&
      onSelect({ target: { name, value: Array.isArray(option) ? option?.map(({ value }) => value) : option?.value } });
  };

  const currentValue = useMemo(() => {
    if (Array.isArray(value)) {
      return options.filter(({ value: v }) => value?.includes(v));
    } else {
      return options.find(({ value: v }) => value === v) || "";
    }
  }, [options, value]);

  return (
    <Select
      classNamePrefix="behind-orders"
      open={true}
      closeMenuOnSelect={closeMenuOnSelect}
      isDisabled={isDisabled}
      isMulti={isMulti}
      styles={{ container: (styles) => ({ ...styles, width: "100%" }) }}
      menuPosition="fixed"
      placeholder={placeholder}
      options={options}
      value={currentValue}
      onChange={handleSelect}
    />
  );
}
